import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const handleExport = (filteredData) => {
    if (!filteredData || filteredData.length === 0) {
        alert('No data available to export!');
        return;
    }
    
    const worksheet = XLSX.utils.json_to_sheet(filteredData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'enquiryData');

    // Write the workbook and create a Blob
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Save the file
    saveAs(dataBlob, 'enquiryData.xlsx');
};